import http from '@/api/http';

export default async (file: File): Promise<any> => {
    const endpoint = '/ttd/audit-upload';
    const formData = new FormData();
    formData.append('file', file);

    const res = await http.post(endpoint, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return res;
};
